import { Space } from "components/Common/Space";
import { TestQuestionItem } from "../TestQuestionItem";
import { TTestExercise, TTestExerciseQuestionItem } from "types/app/exercises";
import "./TestQuestionList.styles.scss";

type TTestQuestionListProps = {
  /**
   * Array of test exercise question data.
   * @default []
   */
  questions?: TTestExerciseQuestionItem[];
  /**
   * Current exercise object with all questions.
   */
  exercise: TTestExercise;
  /**
   * The chapter ID containing the exercise.
   */
  chapterId: number;
  /**
   * Whether it’s a homework exercise.
   */
  isHomeworkExercise: boolean;
  /**
   * Function to update the exercise.
   */
  onUpdateExercise: (updatedExercise: TTestExercise) => void;
};

export const TestQuestionList: React.FC<TTestQuestionListProps> = (props) => {
  const {
    questions = [],
    exercise,
    isHomeworkExercise,
    onUpdateExercise,
  } = props;
  return (
    <Space direction="vertical" size="medium" justify="start" fullWidth>
      {questions.map((item, index) => (
        <TestQuestionItem
          key={item.id}
          question={item}
          exercise={exercise}
          isHomeworkExercise={isHomeworkExercise}
          onUpdateExercise={onUpdateExercise}
          order={index + 1}
        />
      ))}
    </Space>
  );
};
